/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ProtectedRoute from "../../../components/ProtectedRoute";
import Literarte from "../../../components/SlateComponents/Literarte";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import "./styles.css";

class ActivityLiterate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activity: null,
      loading: true,
      production: null
    };
  }

  async componentDidMount() {
    const res = await axios.get(
      // `${URL.api}literarte/activity/singleView/${this.props.id}`,
      `${URL.api}literarte/activity/singleView/73`,
      { headers: { Authorization: `Bearer ${this.props.user.token}` } }
    );

    this.setState(
      {
        activity: res.data.data
      },
      () => this.setState({ loading: false })
    );

    // let obj = {
    //   id: 73,
    //   user_id: 7
    // };

    // axios
    //   .post(`${URL.api}literarte/production/singleView`, obj, {
    //     headers: { authorization: `Bearer ${this.props.user.token}` }
    //   })
    //   .then(
    //     resp => {
    //       if (resp.data.data) {
    //         const text = JSON.parse(resp.data.data.pages[0].content);
    //         this.props.onChange(text);

    //         this.setState({
    //           production: resp.data.data
    //         });
    //       } else {
    //         const text = [
    //           {
    //             type: "paragraph",
    //             children: [{ text: "" }]
    //           }
    //         ];

    //         this.props.onChange(text);
    //       }

    //       this.setState({
    //         loading: false
    //       });
    //     },
    //     err => {
    //       const text = [
    //         {
    //           type: "paragraph",
    //           children: [{ text: "" }]
    //         }
    //       ];

    //       this.props.onChange(text);

    //       this.setState({
    //         loading: false
    //       });
    //     }
    //   );
  }

  render() {
    return (
      <div className="literarte-page">
        {!this.state.loading ? (
          <Literarte
            activity={this.state.activity}
            production={this.state.production}
            value={[
              {
                type: "paragraph",
                children: [{ text: "" }]
              }
            ]}
            placeholder="Digite aqui"
            edit
          />
        ) : (
          <h1>Não carregou ainda</h1>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

ActivityLiterate.defaultProps = {
  hideLayout: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLiterate);
